import HoldOn from 'react-hold-on';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiUrl from '../../ApiUrl';
import axios from 'axios';
import toast from 'react-hot-toast';

// export const GetStudentAPI = createApi({
//     reducerPath: 'studentApi',
//     baseQuery: fetchBaseQuery({
//         baseUrl: apiUrl,
//         prepareHeaders: (headers) => {
//             headers.set('Content-Type', 'application/json');
//             return headers;
//         },
//     }),
//     endpoints: (builder) => ({
//         getStudent: builder.query({
//             query: (studentId) => `remitters/${encodeURIComponent(remitterId)}`,
//             // keepUnusedDataFor: 60,
//             async onQueryStarted(arg, { dispatch, queryFulfilled }) {
//                 const options = {
//                     theme: 'sk-folding-cube',
//                     message: 'Processing Student Data...',
//                     textColor: 'pink',
//                 };
//                 try {
//                     HoldOn.open(options);
//                     const { data } = await queryFulfilled;
//                     // dispatch(remitterSuccess(data));
//                 } catch (error) {
//                     console.error("Error in remitter api:", error);
//                 } finally {
//                     HoldOn.close();
//                 }
//             },
//         }),
//     }),
// });
// export const { useGetStudentQuery } = GetStudentAPI;

export const StudentCreates = (body) => async (dispatch) => {
    let options = {
        theme: 'sk-cube-grid',
        message: 'Creating Student ...',
    }
    try {
        HoldOn.open(options);
        const response = await axios.post(`http://localhost:5001/api/v2/users/insert-data`, body,


        )
        console.log("Response of create beneficiary api:- ", response.data)
        if (response.data) {
            alert("Beneficiary created successfully")
            // navigate('/beneficiary');

        }
    }
    catch (error) {
        console.error("Error in beneficiary api:- ", error)
    }
    finally {
        HoldOn.close();
    }
}

export const StudentUpdates = (studentId, body) => async (dispatch) => {
    let options = {
        theme: 'sk-cube-grid',
        message: 'Updating Student ...',
    }
    try {
        HoldOn.open(options);
        
        const myHeaders = {
            "student_id": studentId,
            "Content-Type": "application/json"
        };

        const response = await axios.put(
            `${apiUrl}users/update/student_id`,
            body,
            { headers: myHeaders }
        );

        console.log("Response of update student api:- ", response.data)
        if (response.data) {
            toast.promise(Promise.resolve(response.data), {
                loading: "Updating Student...",
                success: <b>Student updated successfully!</b>,
                error: <b>Could not update student.</b>,
              });
            // navigate('/student');
        }
    }
    catch (error) {
        console.error("Error in student update api:- ", error)
    }
    finally {
        HoldOn.close();
    }
}